<template>
  <div>
    <nav aria-label='breadcrumb'>
      <ol class='breadcrumb'>
        <li class='breadcrumb-item'>
          <a href='#'>{{translations('navbar.purchase_management')}}</a>
        </li>
        <li class='breadcrumb-item'>
          <router-link to='/archive-purchase-stockings'>{{translations('arrival.archive_arrival')}}</router-link>
        </li>
        <li class='breadcrumb-item active' aria-current='page'>{{translations('arrival.arrival_detail')}}</li>
      </ol>
    </nav>
    <div class='container-fluid main-container'>
      <div class='d-flex flex-wrap'>
        <div class='left-container'>
<!--           <div class='form-inline mb-4'>
            <div class='form-group'>
              <button class='btn btn-primary' :disabled="(Number(stockingInfo.stocking_status) === 2)" data-toggle="modal" data-target="#SinglePurchaseStockingsClaimModal">被請求処理</button>
            </div>
          </div> -->
          <h5 class='mb-3'>Information</h5>
          <table class='table table-sm table-borderless table-information'>
            <tbody>
              <tr>
                <th>{{translations('purchase.order_date')}}</th>
                <td>{{ formatDateAt(stockingInfo.purchase_at) }}</td>
              </tr>
              <tr>
                <th>{{translations('purchase.name')}}</th>
                <td>
                  <button
                    ref='info02'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info02'
                    data-placement='right'
                  >{{ stockingInfo.name ? stockingInfo.name : '-----------' }}</button>
                  <div id='popover-info02' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('purchase.name')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <input type='text' v-model="tempInfo.name" class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('name', tempInfo.name, 'info02')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('purchase.client_order_number')}}</th>
                <td>{{stockingInfo.stocking_number}}</td>
              </tr>
              <tr>
                <th>{{translations('arrival.supplier')}}</th>
                <td>{{stockingInfo.kaishu_partner_name}}</td>
              </tr>
              <tr>
                <th>{{translations('arrival.closing_date')}}</th>
                <td>{{ formatDateAt(stockingInfo.closing_at) }}</td>
              </tr>
              <tr>
                <th>{{translations('purchase.arrival_date')}}</th>
                <td>{{ formatDateAt(stockingInfo.stocked_at) }}</td>
              </tr>
              <tr>
                <th>{{translations('purchase.warehouse')}}</th>
                <td>{{stockingInfo.kaishu_warehouse_name}}</td>
              </tr>
              <tr>
                <th>{{translations('purchase.remarks')}}</th>
                <td>
                  <button
                    ref='info08'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info08'
                    data-placement='right'
                  >{{ stockingInfo.memo ? stockingInfo.memo : '-----------' }}</button>
                  <div id='popover-info08' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('purchase.remarks')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <textarea class='form-control' v-model="tempInfo.memo"></textarea>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('memo', tempInfo.memo, 'info08')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('common.last_updated_by')}}</th>
                <td>{{stockingInfo.updated_by}}</td>
              </tr>
              <tr>
                <th>{{translations('common.last_update_time')}}</th>
                <td>{{stockingInfo.updated_at}}</td>
              </tr>
            </tbody>
          </table>
          <hr>
          <h5 class="mb-3">Files</h5>
          <div class="card" :class="(deliveryFile == null) ? 'hidden' : ''">
            <ul class="list-group list-group-flush">
              <li class="list-group-item list-group-item-info d-flex justify-content-between"><a @click="openDeliveryFile">{{translations('arrival.delivery_slip')}}<i class="fas fa-external-link-alt"></i></a><button type="button" class="btn btn-link p-0 mr-1" @click="deliveryFile = null"><i class="far fa-times-circle"></i></button></li>
            </ul>
          </div>
          <div class="card" :class="(deliveryFile != null) ? 'hidden' : ''">
            <ul class="list-group list-group-flush">
              <li class="list-group-item"><button class="btn btn-link p-0" type="button" data-toggle="modal" data-target="#DeliveryFileModal">{{translations('arrival.delivery_slip')}}<i class="fas fa-paperclip"></i></button></li>
            </ul>
          </div>
          <hr>
          <div class='form-inline'>
            <div class='form-group'>
              <a class='btn btn-link btn-sm text-danger' @click.self="deleteStocking()" data-href='#'>{{translations('common.delete')}}</a>
            </div>
          </div>
        </div>
        <div class='right-container'>
          <div class="form-inline justify-content-end"><!-- VAT -->
            <div v-if="taxIncluded" class="text-danger">{{translations('common.tax_included')}}</div><!-- TAXSTATUS -->
            <div v-else>{{translations('common.tax_excluded')}}</div>
          </div>
          <div class='table-scroll mb-4'>
            <table class='table table-sm table-striped table-1000'>
              <thead>
                <tr>
                  <th></th>
                  <th>{{translations('purchase.jan_code')}}</th>
                  <th>{{translations('purchase.model')}}</th>
                  <th style="min-width:80px;">{{translations('purchase.unit_price')}}</th>
                  <th style="min-width:80px;">{{translations('purchase.count')}}</th>
                  <th>{{translations('purchase.summary')}}</th>
                  <th>{{translations('purchase.total_amount')}}</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(detail, i) in stockingDetails">
                  <tr :key="i">
                    <td></td>
                    <td>{{ detail.jan_code }}</td>
                    <td>{{ detail.model }}</td>
                    <td class="right">{{ toTaxFormat(detail, 'unit_price') }}</td>
                    <td class="right" style="padding-right:40px;">{{ Number(detail.quantity).toLocaleString() }}</td>
                    <td>{{ detail.remarks }}</td>
                    <td class="right">{{ toTaxFormat(detail, 'total_price') }}</td>
                  </tr>
                </template>
                <tr class='bg-lightgreen'>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class='font-weight-bold right'>{{ Number(grandTotalUnitPrice).toLocaleString() }} ({{ Number(grandTotalUnitPriceIncTax).toLocaleString() }})</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class='form-inline'>
            <div class='form-group'>
              <button class='btn btn-sm btn-primary' @click="updateStockings()">{{translations('common.update')}}</button>
            </div>
            <div class="form-group">
              <a class="btn btn-link btn-sm decoration-underline" @click="openStockingPdf()" href="#">{{translations('arrival.goods_receipt_output')}}<i class="fas fa-external-link-alt"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <SinglePurchaseStockingsClaimModal :stockingID="stockingId" /> -->
    <DeliveryFileModal :delivery-file="deliveryFile" />
    <vue-element-loading :active='isLoading' :is-full-screen='true'/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
// import SinglePurchaseStockingsClaimModal from '@/components/purchase/SinglePurchaseStockingsClaimModal'
import DeliveryFileModal from '@/components/purchase/DeliveryFileModal'
import { mapState } from 'vuex'

export default {
  name: 'SinglePurchaseStockings',
  props: {},
  components: {
    VueElementLoading,
    // SinglePurchaseStockingsClaimModal,
    DeliveryFileModal
  },

  data () {
    return {
      vatRate: 0, // VAT
      taxIncluded: false, // VAT
      stockingId: 0,
      stockingInfo: {},
      stockingDetails: [],
      tempInfo: {},
      grandTotalUnitPrice: null,
      grandTotalUnitPriceIncTax: null,
      isLoading: true,
      deliveryFile: null,
      stockingPdf: null
    }
  },

  watch: {
    stockingDetails: {
      handler (v) {
        let $this = this
        v.forEach((d, i) => {
          if (typeof d !== 'undefined') {
            v[i] = $this.prepareDetails(d)
          }
        })
        this.calcGrandTotals()
      },
      deep: true
    }
  },

  created () {
    if (!this.$route.query.stocking_id) {
      this.$router.replace('archive-purchase-stockings')
    }

    this.stockingId = Number(this.$route.query.stocking_id)
    this.getStocking().catch(error => {
      this.$toastr.error(error.message, 'エラー')
    }).finally(() => {
      this.popoverButtons()
    })
    // this.getPoFile()
    // this.getStockingPdf()
  },

  computed: {
    ...mapState(['currentLanguage']),
    confirmationDeleteArrivalMessage () {
      return this.translations('arrival.delete_arrival')
    },
    confirmationUpdateArrivalMessage () {
      return this.translations('arrival.update_arrival')
    },
    confirmButtonText () {
      return this.translations('common.yes')
    },
    cancelButtonText () {
      return this.translations('common.no')
    }
  },

  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    getStocking () {
      this.isLoading = true
      return this.$http.post(this.$api_url.purchase_stocking_details, { stocking_id: this.stockingId }).then(response => {
        const result = response.data
        if (result.status === true) {
          this.stockingInfo = result.information
          this.stockingDetails = result.details
          this.taxIncluded = result.information.tax_included
          this.vatRate = result.information.tax_rate
          this.deliveryFile = result.information.delivery_file

          this.tempInfo = JSON.parse(JSON.stringify(this.stockingInfo))
        } else {
          return Promise.reject(new Error(result.message))
        }
      }).catch(function (error) {
        console.log('SinglePurchaseStockings:getStocking:catch(error): ', error)
        return Promise.reject(new Error('エラーのため失敗しました。ご確認後、再試行してください。'))
      }).finally(() => {
        this.isLoading = false
      })
    },

    formatDateAt (v, b = 0) {
      if (!v) return '-----------'
      if (v.indexOf('-') > 0) {
        const x = /-/gi
        return v.replace(x, '/')
      } else {
        if (b) return v.substr(0, 4) + '-' + v.substr(4, 2) + '-' + v.substr(6, 2)
        else if (v.indexOf('/') > 0) return v
        else return v.substr(0, 4) + '/' + v.substr(4, 2) + '/' + v.substr(6, 2)
      }
    },

    openDeliveryFile () {
      if (this.deliveryFile != null) {
        let arrBuff = this.__b64ToArrayBuffer(this.deliveryFile.replace('data:application/pdf;base64,', ''))
        const pdfFile = new Blob([arrBuff], { type: 'application/pdf' })
        const pdfFileURL = URL.createObjectURL(pdfFile)
        window.open(pdfFileURL)
      }
    },

    async openStockingPdf () {
      if (!this.stockingPdf) {
        try {
          const response = await this.$http.post(
            this.$api_url.purchase_stocking_pdf,
            { stocking_id: this.stockingId }
          )
          console.log('SinglePurchaseStockings:getStockingpdf', response)
          if (response.data.status === true && response.data.pdf) {
            this.stockingPdf = response.data.pdf
          } else {
            this.stockingPdf = null
          }
        } catch (error) {
          console.log('SinglePurchaseStockings:getstockingPdf:catch(error): ', error)
          this.$toastr.error('物品受領書が取得できませんでした。ご確認後、再試行してください。', 'エラー')
        }
      }

      if (this.stockingPdf) {
        let arrBuff = this.__b64ToArrayBuffer(this.stockingPdf.replace('data:application/pdf;base64,', ''))
        const stockingPdf = new Blob([arrBuff], { type: 'application/pdf' })
        const stockingPdfURL = URL.createObjectURL(stockingPdf)
        window.open(stockingPdfURL)
      }
    },

    __b64ToArrayBuffer (base64) {
      let binaryString = window.atob(base64)
      let len = binaryString.length
      let bytes = new Uint8Array(len)
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes.buffer
    },

    popoverButtons () {
      window.$('button[data-toggle="popover-x"]').each(function () {
        let targetID = window.$(this).attr('data-target')
        window.$(this).popoverButton({
          target: targetID,
          trigger: 'click'
        })
      })
    },

    /**
     * @param field : sales information props
     * @param value : value
     * @param ref   : reference trigger
     */
    updateField (field, value, ref) {
      let val = ''
      const rg = /^\s+$/
      if (
        value === '-' ||
        value === '' ||
        rg.test(value) === true ||
        typeof value === 'undefined'
      ) {
        this.$refs[ref].innerText = '-----------'
        val = ''
      } else {
        this.$refs[ref].innerText = value
        val = value
      }
      this.stockingInfo[field] = val
      window.$('#popover-' + ref).popoverX('hide')
    },

    deleteDetail (i) {
      this.stockingDetails.splice(i, 1)
    },

    toTaxFormat (data, key) {
      const price = data[key] || 0

      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        if (key === 'unit_price') {
          data.unit_price = price
          data.unit_price_inctax = price
        }
        return Number(price).toLocaleString()
      }

      const taxIncluded = data.tax_included || this.taxIncluded
      const taxRate = Number(data.tax_rate || this.taxRate)
      const inctax = this.$util.getIncludeTax(price, taxRate)
      if (key === 'unit_price') {
        data.unit_price = price
        data.unit_price_inctax = inctax
      }
      if (!taxIncluded) { // 税込以外
        return `${Number(price).toLocaleString()} (${Number(inctax).toLocaleString()})`
      } else {
        return `${Number(inctax).toLocaleString()} (${Number(price).toLocaleString()})`
      }
    },

    prepareDetails (data) {
      data.total_unit_price = data.quantity * data.unit_price

      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        data.unit_price_inctax = Number(data.unit_price)
        data.total_unit_price_inctax = data.total_unit_price
      } else {
        data.unit_price_inctax = this.$util.getIncludeTax(data.unit_price, Number(data.tax_rate || this.taxRate))
        data.total_unit_price_inctax = this.$util.getIncludeTax(data.total_unit_price, data.tax_rate)
      }

      return data
    },

    calcGrandTotals () {
      this.grandTotalUnitPrice = 0
      this.grandTotalUnitPriceIncTax = 0

      this.stockingDetails.forEach(v => {
        this.grandTotalUnitPrice += Number(v.total_unit_price)
      })

      this.grandTotalUnitPriceIncTax = this.$util.getIncludeTax(this.grandTotalUnitPrice, this.taxRate)
    },

    updateStockings () {
      this.$dialog.confirm(this.confirmationUpdateArrivalMessage, {
        okText: this.confirmButtonText,
        cancelText: this.cancelButtonText
      }).then(async () => {
        try {
          if (this.deliveryFile != null) {
            this.stockingInfo.delivery_file = this.deliveryFile
          } else {
            this.stockingInfo.delivery_file = null
          }

          this.isLoading = true

          const paramUpdate = {
            stocking_id: this.stockingId,
            information: this.stockingInfo,
            details: this.stockingDetails
          }
          const updateSale = await this.$http.post(this.$api_url.purchase_stocking_update, paramUpdate)
          const $data = this.$invoiceTools.prepareResult(updateSale.data)
          console.log('SinglePurchaseStockings:updateStockings: ', $data)
          if ($data.success === true) {
            this.$toastr.success('入荷情報の保存に成功しました。', 'Success')
          } else {
            this.$toastr.error($data.data, 'エラー')
          }
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          console.log('SinglePurchaseStockings:updateStockings:catch(error): ', error)
          this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
        }
      })
    },

    deleteStocking () {
      let $this = this
      this.$dialog.confirm(this.confirmationDeleteArrivalMessage, {
        okText: this.confirmButtonText,
        cancelText: this.cancelButtonText
      })
        .then(async () => {
          this.isLoading = true
          try {
            let del = await this.$http.post(this.$api_url.purchase_stocking_delete, { stocking_id: $this.stockingId })
            let $data = this.$invoiceTools.prepareResult(del.data, '', 'SinglePurchaseStockings:deleteStocking')
            if ($data.success === true) {
              this.$toastr.success('入荷情報を削除しました', 'Success')
              this.$router.replace('archive-purchase-stockings')
              setTimeout(() => { this.isLoading = false }, 1000)
            } else {
              this.$toastr.error($data.data, 'エラー')
            }
            $this.isLoading = false
          } catch (error) {
            $this.isLoading = false
            console.log('SinglePurchaseStockings:deleteStocking:catch(error): ', error)
            this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
          }
        }).catch(() => { console.log('Clicked `Cancel`') })
    }
  }
}
</script>
